import type { FC } from 'react';

import { MainNavigationBar } from 'src/components-v2/MainNavigationBar';
import { MainNavigationBar2 } from 'src/components-v2/MainNavigationBar2';
import { TLocale } from 'src/lib/constants';
import type { NavigationVariant } from 'src/lib/site-navigation';

interface SiteNavigationProps {
  locale: TLocale;
  skipLinkAnchor?: string;
  variant?: NavigationVariant;
}

const SiteNavigation: FC<SiteNavigationProps> = ({
  locale,
  skipLinkAnchor,
  variant = 'default',
}) => {
  if (variant === 'minimal') {
    return (
      <MainNavigationBar skipLinkAnchor={skipLinkAnchor} variant='minimal' />
    );
  }

  // Nav data only exists for en-us; other locales keep the previous navigation.
  if (locale !== 'en-us') {
    return <MainNavigationBar skipLinkAnchor={skipLinkAnchor} />;
  }

  return <MainNavigationBar2 skipLinkAnchor={skipLinkAnchor} />;
};

export default SiteNavigation;
